import { useEffect, useState } from 'react'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { Box, Paper, styled } from '@mui/material'
import { useApplicationSettings, useSharedFolder } from 'hooks'
import { Overview } from './Overview'
import {
    ItemDetails,
    LeftPaneActions,
    LeftPaneTabs,
    TextFormatter,
    Button,
} from 'components'
import { InventoriedPermissions } from './Inventoried Permissions'
import { PageContextProvider } from 'pageContext'
import { AccessManagers } from './Access Managers (Owners)'
import { useIsSmallScreenFalse, useQuery } from 'packages/core'
import { useTranslation } from 'react-i18next'
import bgHeader from '../../../assets/images/bgHeader.png'
import StickyContainer from 'components/StickyContainer'
import useSubcomponents from 'useSubcomponents'
import { useHistory } from 'react-router'
import { AcessAssignmentsFolder } from './AcessAssignmentsFolder/AcessAssignmentsFolder'
import { DirectAssignedLocations } from './DirectAssignedLocations/DirectAssignedLocations'
import { IAmShopAssignments } from './IAMShopAssignments'
import { IAmShopAssignees } from './IAMShopAssignees'
import { useAppState } from 'appContext'
import {
    getAccessibleTabs,
    RESOURCE_TYPE_NAMES,
    updateUrlQueryParams,
} from 'utils'
import { AccessRequestPolicy } from 'components/AccessRequestPolicy/AccessRequestPolicy'
const HeaderContainer = styled(Box)({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0px 48px 0px 32px',
    overflow: 'hidden',
    color: '#ffffff',
    fontSize: '22px',
    textAlign: 'center',
})
const smallScreenWidth = 960

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            position: 'relative',
            height: '100%',
            width: '100%',

            [`@media (max-width:${smallScreenWidth - 1}px)`]: {
                flexDirection: 'column',
            },
        },
        imgContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            width: '100%',
            minHeight: '125px',
            borderRadius: '8px',
            marginBottom: '20px',
            '& img': {
                maxHeight: '80px',
                maxWidth: '80px',
            },
            [`@media (max-width:${smallScreenWidth - 1}px)`]: {
                minWidth: '116px',
                '& img': {
                    maxHeight: '33px',
                    width: '66px',
                },
            },
        },
        nameContainer: {
            width: '100%',
            minHeight: '50px',
            marginBottom: '20px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            overflow: 'hidden',
            fontSize: '22px',
            fontWeight: 'bold',
            borderRadius: '8px',
            color: '#3b454d',
            wordBreak: 'break-word',
            padding: '0.5rem',
        },
        tabsContainer: {
            width: '100%',
            borderRadius: '0px',
            marginBottom: '20px',
        },
        section: {
            display: 'flex',
            justifyContent: 'flex-start',
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            flexWrap: 'wrap',
            width: '100%',
            [`@media (max-width:${smallScreenWidth - 1}px)`]: {
                display: 'none',
            },
        },
        basicInfo: {
            display: 'flex',
            flexDirection: 'column',
        },
        description: {
            [`@media (min-width:1366px)`]: {
                maxWidth: '300px',
            },
        },
        actionsContainer: {
            minWidth: '230px',
            paddingRight: theme.spacing(2),

            [`@media (max-width:445px)`]: {
                alignItems: 'flex-start',
            },
        },
        backButton: {
            '& >button': {
                '&:hover': {
                    backgroundColor: theme?.palette?.primary?.main,
                    color: 'white',
                    '& span': {
                        color: theme.palette.common.white,
                    },
                },
            },
        },
        moreInfoButton: {
            marginTop: theme.spacing(3),
            '& >button': {
                backgroundColor: theme.palette.grey[900],
                color: theme.palette.common.white,

                border: `solid 1px ${theme.palette.grey[900]}`,

                '&:hover': {
                    backgroundColor: theme.palette.grey[900],

                    '& span': {},
                },
            },
        },
        actionDropdown: {
            marginTop: '40px',
        },
        showMoreButton: {
            [`@media (min-width:${smallScreenWidth}px)`]: {
                display: 'none',
            },
            position: 'absolute',
            bottom: '-15px',
            left: 'calc(50% - 83px)',
            zIndex: 2,
            '& > button': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#ffffff',
                border: 'none',
                height: '32px',
                minWidth: '115px',
                color: theme?.palette?.primary?.main,
                fontSize: '11px',
                textTransform: 'uppercase',
                borderRadius: '15px',
                boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
                cursor: 'pointer',
                paddingLeft: '12px',
                paddingRight: '6px',
                '& svg': {
                    color: theme?.palette?.primary?.main,
                    height: '20px',
                },
            },
        },
        collapsibleContainer: {
            display: 'flex',
            flexDirection: 'column',
            [`@media (min-width:${smallScreenWidth}px)`]: {
                display: 'none',
            },
            '& div': {
                textAlign: 'start',
            },
        },
        actionContainerMobile: {},
        azureApplicationDetailsLabel: {
            color: '#1b1f1f',
            textDecoration: 'underline',
        },

        azureApplicationDetailsIdValues: {
            color: theme?.palette?.primary?.main,
        },

        content: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',

            [`@media (max-width:${smallScreenWidth - 1}px)`]: {
                paddingBottom: theme.spacing(2),
            },
            [`@media (max-width:345px)`]: {
                flexDirection: 'column-reverse',
            },
        },
        commonDeputies: {
            'flex-wrap': 'nowrap',
        },
        totalCountLabel: {
            borderRadius: '8px',
            minWidth: '29px',
            height: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '7px',
            marginTop: '3px',
            marginLeft: '5px',
            fontSize: '11px',
        },
    }),
)
export const TabsColumn = styled(Box)({
    display: 'flex',
    minWidth: '340px',
    flexDirection: 'column',
    margin: '0px 12px 0px 10px',
    marginRight: '20px',
    width: '30%',
    flex: '36%',
})

export const SharedFolderDetails = (props) => {
    const classes = useStyles()
    const { tabs, basicAttributes, sharedFolderId, accessRequestAttributes } =
        props
    const {
        isLoading: detailsLoading,
        data: sharedFolder,
        refetch,
    } = useSharedFolder(sharedFolderId)
    const query = useQuery()
    const [, dispatch] = useAppState()
    const isSmallScreen = useIsSmallScreenFalse()
    const { data: appConfig } = useApplicationSettings()
    const { t } = useTranslation()
    const { hasAccessToControl } = useSubcomponents()
    const history = useHistory()
    const [activeTab, setActiveTab] = useState(null)
    const [allAccessibleTabs, setAllAccessibleTabs] = useState([])

    useEffect(() => {
        if (sharedFolder) {
            const queryActiveTab = query.get('activeTab')
            const queryActiveSubTab = query.get('subActiveTab')
            const activeTabInfo = getAccessibleTabs(
                query,
                history,
                tabs,
                queryActiveTab,
                queryActiveSubTab,
                hasAccessToControl,
                'activeTab',
                'subActiveTab',
            )
            setAllAccessibleTabs(activeTabInfo.allAccessibleTabs)
            setActiveTab(activeTabInfo.activeTab)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sharedFolder])

    const handleTabChange = (tab) => {
        setActiveTab(tab)
        updateUrlQueryParams(
            query,
            history,
            [{ key: 'activeTab', value: tab }],
            ['subActiveTab', 'returnedFromWorkflow'],
        )
    }

    useEffect(() => {
        if (sharedFolderId && sharedFolder?.id) {
            dispatch({
                type: 'SET_CURRENT_RESOURCE',
                payload: {
                    targetAssigneeId: sharedFolderId,
                    targetAssigneeFriendlyName:
                        sharedFolder?.friendlyName ??
                        t(RESOURCE_TYPE_NAMES.SHARED_FOLDER),
                    targetAssignee_ResourceTypeFriendlyName: t(
                        RESOURCE_TYPE_NAMES.SHARED_FOLDER,
                    ),
                },
            })

            dispatch({
                type: 'SET_TARGET_RESOURCE',
                payload: {
                    targetAssigneeId: sharedFolderId,
                    targetAssigneeFriendlyName:
                        sharedFolder?.friendlyName ??
                        t(RESOURCE_TYPE_NAMES.SHARED_FOLDER),
                    targetAssignee_ResourceTypeFriendlyName: t(
                        RESOURCE_TYPE_NAMES.SHARED_FOLDER,
                    ),
                },
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sharedFolderId, sharedFolder?.id])
    if (isSmallScreen) {
        return (
            <>
                <StickyContainer
                    color="#ffffff"
                    styles={{
                        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Box
                        width="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                    >
                        <Box paddingY="10px" width="100%" maxWidth="260px">
                            <Button.BackButton
                                onClick={() => {
                                    history.push(history.location.pathname)
                                }}
                            >
                                {t('BackToSharedFolderList')}
                            </Button.BackButton>
                        </Box>

                        <HeaderContainer
                            height="80px"
                            textAlign="start"
                            bgcolor={appConfig.style.colors.primary?.header}
                            style={{
                                backgroundImage: `url(${bgHeader})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                            }}
                        >
                            <TextFormatter
                                value={
                                    sharedFolder?.name ??
                                    sharedFolder?.description
                                }
                                maxCharacters={75}
                            />
                        </HeaderContainer>
                    </Box>
                </StickyContainer>
                <ItemDetails.Tabs
                    variant="scrollable"
                    value={activeTab}
                    onChange={(_, value) => handleTabChange(value)}
                    style={{ background: '#fbfbfd' }}
                >
                    {allAccessibleTabs.map((tab, index) => (
                        <ItemDetails.Tabs.Tab
                            key={index + tab.value}
                            value={tab.value}
                            label={t(tab.label)}
                        />
                    ))}
                </ItemDetails.Tabs>
                <Box className={classes.root}>
                    {activeTab === 'overview' && (
                        <Overview
                            sharedFolderId={sharedFolderId}
                            detailsLoading={detailsLoading}
                            basicAttributes={basicAttributes}
                        />
                    )}
                    {activeTab === 'inventoriedPermissions' && (
                        <PageContextProvider key="RequestViewSharedFolderPermissions">
                            <InventoriedPermissions
                                sharedFolderId={sharedFolderId}
                            />
                        </PageContextProvider>
                    )}
                    {activeTab === 'assignments' && (
                        <PageContextProvider key="RequestViewSharedFolderAssignments">
                            <IAmShopAssignments resource={sharedFolder} />
                        </PageContextProvider>
                    )}
                    {activeTab === 'assignees' && (
                        <PageContextProvider key="RequestViewSharedFolderAssignees">
                            <IAmShopAssignees
                                sharedFolder={sharedFolder}
                                id={sharedFolderId}
                            />
                        </PageContextProvider>
                    )}
                    {activeTab === 'accessManagers' && (
                        <PageContextProvider key="RequestViewSharedFolderAccessManagers">
                            <AccessManagers resource={sharedFolder} />
                        </PageContextProvider>
                    )}
                    {activeTab === 'assignmentsFolder' && (
                        <PageContextProvider key="AssignmentsFolder">
                            <AcessAssignmentsFolder
                                sharedFolder={sharedFolder}
                            />
                        </PageContextProvider>
                    )}
                    {activeTab === 'directAssignedLocations' && (
                        <PageContextProvider key="DirectAssignedLocations">
                            <DirectAssignedLocations id={sharedFolderId} />
                        </PageContextProvider>
                    )}
                    {activeTab === 'accessRequestPolicy' && (
                        <PageContextProvider key="AccessRequestPolicy">
                            <AccessRequestPolicy
                                sharedFolderId={sharedFolderId}
                                accessRequestAttributes={
                                    accessRequestAttributes
                                }
                                sharedFolder={sharedFolder}
                                refetch={refetch}
                            />
                        </PageContextProvider>
                    )}
                </Box>
            </>
        )
    }
    return (
        <>
            <Box display="flex">
                <TabsColumn>
                    <Paper className={classes.nameContainer}>
                        {sharedFolder?.friendlyName}
                    </Paper>
                    <Paper className={classes.tabsContainer}>
                        <LeftPaneTabs
                            active={activeTab}
                            onChange={handleTabChange}
                            tabs={allAccessibleTabs}
                        />
                    </Paper>
                    <LeftPaneActions
                        resource={sharedFolder}
                        resourceType="sharedFolders"
                        activeTab={activeTab}
                    />
                </TabsColumn>
                <Box className={classes.root}>
                    {activeTab === 'overview' && (
                        <Paper>
                            <Overview
                                sharedFolderId={sharedFolderId}
                                detailsLoading={detailsLoading}
                                basicAttributes={basicAttributes}
                            />
                        </Paper>
                    )}
                    {activeTab === 'inventoriedPermissions' && (
                        <PageContextProvider key="RequestViewSharedFolderPermissions">
                            <InventoriedPermissions
                                sharedFolderId={sharedFolderId}
                            />
                        </PageContextProvider>
                    )}
                    {activeTab === 'assignments' && (
                        <PageContextProvider key="RequestViewSharedFolderAssignments">
                            <IAmShopAssignments resource={sharedFolder} />
                        </PageContextProvider>
                    )}
                    {activeTab === 'assignees' && (
                        <PageContextProvider key="RequestViewSharedFolderAssignees">
                            <IAmShopAssignees
                                sharedFolder={sharedFolder}
                                id={sharedFolderId}
                            />
                        </PageContextProvider>
                    )}
                    {activeTab === 'accessManagers' && (
                        <PageContextProvider key="RequestViewSharedFolderAccessManagers">
                            <AccessManagers resource={sharedFolder} />
                        </PageContextProvider>
                    )}
                    {activeTab === 'assignmentsFolder' && (
                        <PageContextProvider key="AssignmentsFolder">
                            <AcessAssignmentsFolder
                                sharedFolder={sharedFolder}
                            />
                        </PageContextProvider>
                    )}
                    {activeTab === 'directAssignedLocations' && (
                        <PageContextProvider key="DirectAssignedLocations">
                            <DirectAssignedLocations id={sharedFolderId} />
                        </PageContextProvider>
                    )}
                    {activeTab === 'accessRequestPolicy' && (
                        <PageContextProvider key="AccessRequestPolicy">
                            <AccessRequestPolicy
                                resourceId={sharedFolderId}
                                accessRequestAttributes={
                                    accessRequestAttributes
                                }
                                requestPolicyId={sharedFolder?.requestPolicyId}
                                refetch={refetch}
                            />
                        </PageContextProvider>
                    )}
                </Box>
            </Box>
        </>
    )
}
